/* global global */

// Third-party imports
import $ from 'jquery';
import jQuery from 'jquery';

// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import * as donation_datalayer from '../../donation/datalayer.js';
import * as gc_featured_datalayer from '../../gift_catalogue/datalayer/gc_featuredproduct.js';
import * as gc_tabbed_datalayer from '../../gift_catalogue/datalayer/gc_tabbedproduct.js';
import * as gchome_datalayer from './datalayer.js';
import * as gcnav_datalayer from '../../gift_catalogue/datalayer/gcnav.js';
import * as gccat_datalayer from '../../gift_catalogue/datalayer/gccat.js';
import * as gtm_vars from '../../../component/datalayer/gtm/gtm_vars.js';
import * as gtm_push from '../../../component/datalayer/gtm/gtm_push.js';
import * as global_mod from '../../global/index.js';
import { PAGE_VARS, PageKind } from '../vars.js';
import * as tealium from '../../datalayer/tealium.js';
import * as featured_card_handler from '../../gift_catalogue/card/featured_card_handler.js';
import * as tabbed_card_handler from '../../gift_catalogue/card/tabbed_card_handler.js';
import * as general_donation_cta from '../../global/general_donation_cta.js';

import * as shopify_data from './shopify_data.js';

// Module name
export const MODULE_NAME = 'gchome';

export let global_vars = {};

class ShopifyData {
    constructor(data_element) {
        this.data_element = data_element;
        //set the hardcoded Id if necessary. Preferrably if #gchome-data can contain mapping of featured_gift/card data to
        // respctive element with than set the selector in the respective function for each featured_gift and once for all_card
        this.cardSelector = 'gc-cards-container';
    }

    featured_gift() {
        let all_featured_gift = this.data_element.querySelectorAll(
            '.featured-gift'
        );

        for (let featured_gift of all_featured_gift) {
            let data = featured_gift.dataset;

            if (data.isproduct !== 'true') {
                continue;
            }

            shopify_data.save_gcproduct_data(
                JSON.parse(data.product),
                data.ispromo,
                data.position,

                // collection_title
                data.collection_title,

                data.price,
                data.img_url,
                true
            );
        }
    }

    card() {
        const SHOPIFY_DATA = shopify_data.SHOPIFY_DATA;

        let all_card = this.data_element.querySelectorAll('.card');

        for (let card of all_card) {
            let data = card.dataset;

            SHOPIFY_DATA.cards.push({
                collection: JSON.parse(data.collection),
                img_url: data.img_url,
            });
        }

        // jQuery, dont use ready or .ready as CSS may not be loaded
        // Set The eventlistener with a namespace to not intefer with other listeners on the event, pass extra data el with evt
        let element = global.document.getElementById(this.cardSelector);

        //Again if mapping the element in this all_card element is possibe than pass that where this.cardSelector is used
        $(window).on(
            `DOMContentLoaded.${this.cardSelector} load.${
                this.cardSelector
            } resize.${this.cardSelector} scroll.${this.cardSelector}`,
            { el: element, elSelector: this.cardSelector },
            handler
        );
    }

    general_data() {
        let all_general = this.data_element.querySelectorAll('.general');
        for (let general of all_general) {
            let data = general.dataset;

            let product = {
                id: data.id,
                title: data.title,
                price: data.price,
                variants: data.variants,
            };

            shopify_data.save_general_data(
                product,

                // category name
                'Donations',

                data.ispromo,
                data.img_url
            );
        }
    }

    gcproduct() {
        let all_product = this.data_element.querySelectorAll('.gcproduct');
        for (let product of all_product) {
            let data = product.dataset;

            shopify_data.save_gcproduct_data(
                JSON.parse(data.product),
                data.ispromo,

                // Position
                '1',

                // collection_title
                `Gifts/${data.collection_title}`,

                data.price,
                data.img_url,
                false
            );
        }
    }

    run() {
        this.featured_gift();
        this.card();
        this.general_data();
        this.gcproduct();
    }
}

function isElementInViewport(el) {
    //If el is from jquery selector
    if (typeof jQuery === 'function' && el instanceof jQuery) {
        el = el[0];
    }
    return $(el).offset().top <= $(window).scrollTop() + $(window).height();
}

function onVisibilityChange(data, callback, callbackParam) {
    let old_visible;
    let selector = data.elSelector;
    let visible = isElementInViewport(data.el);
    if (visible !== old_visible) {
        old_visible = visible;
        callback(callbackParam);
        //Remove event listener on window for events with namespace
        $(window).off(
            `DOMContentLoaded.${selector} load.${selector} resize.${selector} scroll.${selector}`
        );
    }
}

let handler = function(evt) {
    //add all elements that need to track
    //utilize data variable passed in evt. Keeps handler function reusable for other
    onVisibilityChange(evt.data, gtm_push.push_product_impressions, global);
};

function process_shopify_data(global) {
    const SHOPIFY_DATA = shopify_data.SHOPIFY_DATA;

    let data_element = global.document.getElementById('gchome-data');
    let shpdata = new ShopifyData(data_element);
    shpdata.run();

    // gcproduct
    for (let d of SHOPIFY_DATA.gcproduct) {
        gchome_datalayer.update_datalayer(
            d.product,
            d.ispromo,
            d.position,
            d.collection_title,
            d.product_price,
            d.img_url,
            d.featured
        );
    }

    // Cards
    for (let d of SHOPIFY_DATA.cards) {
        gchome_datalayer.update_cards_datalayer(d.collection, d.img_url);
    }

    // General donation
    for (let d of SHOPIFY_DATA.general) {
        donation_datalayer.update_datalayer(
            d.product,
            d.category,
            d.ispromo,
            d.img_url
        );
    }
}

function init_pagevars() {
    PAGE_VARS.kind = PageKind.GiftCatalogue;
}

function initialize(global) {
    process_shopify_data(global);
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    // Create object to pass to global initialization
    let all_modules = [];
    all_modules.push.apply(all_modules, global_mod.__all__);

    let gchome_mod = {
        MODULE_NAME,
        global_vars,
        initialize,
    };

    all_modules.push(
        gchome_mod,
        featured_card_handler,
        tabbed_card_handler,
        general_donation_cta,
        gtm_vars,
        gcnav_datalayer,
        gccat_datalayer,
        gc_featured_datalayer,
        gc_tabbed_datalayer,
        gtm_push
    );

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    global_mod.initialize(global, all_modules);
}
